<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <h2 class="mb-4">
              {{ $t("licenseAgreement") }}
            </h2>

            <p>
                {{ $t("licenseAgreementContent.line1") }}
            </p>

            <ul class="spaced-list">
                <li>
                    {{ $t("licenseAgreementContent.line2") }}

                    <ul>
                        <li>
                            {{ $t("licenseAgreementContent.line3") }}
                        </li>

                        <li>
                            {{ $t("licenseAgreementContent.line4") }}
                        </li>
                    </ul>
                </li>

                <li>
                    {{ $t("licenseAgreementContent.line5") }}

                    <ul>
                        <li>
                           {{ $t("licenseAgreementContent.line6") }}
                        </li>

                        <li>
                            {{ $t("licenseAgreementContent.line7") }}
                        </li>
                    </ul>
                </li>

                <li>
                    {{ $t('licenseAgreementContent.line8', { number: $app.signedUrlDurationDays }) }}
                </li>

                <li>
                    {{ $t("licenseAgreementContent.line9") }}
                </li>

                <li>
                    {{ $t("licenseAgreementContent.line10") }}
                </li>

                <li>
                    {{ $t("licenseAgreementContent.line11") }}
                </li>

                <li>
                    {{ $t("licenseAgreementContent.line12") }}
                </li>

                <li>
                    {{ $t("licenseAgreementContent.line13") }}
                </li>

                <li>
                    <a href="https://www.biblegateway.com/passage/?search=1+Corinthians+9%3A9-11&version=NIV"
                        title="Read 1 Cor. 9:9-11" target="_blank">{{ $t("licenseAgreementContent.line14") }}</a>
                </li>
            </ul>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";

export default {
    name: "LicenseAgreement",

    components: {
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("licenseAgreement")}`,
        };
    },
};
</script>
